import { Grid } from '@mui/material';
import { ODSTextArea } from '@telekom-ods/react-ui-kit';
import type { FC, ChangeEvent, FocusEvent } from 'react';

import type { InputPropsType } from '@/types/inputTypes';

interface TextAreaProps {
  name: string;
  value?: string;
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (event: FocusEvent<HTMLTextAreaElement>) => void;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  supportMessage?: string;
  InputProps?: InputPropsType;
  size?: 'small' | 'large';
  readOnly?: boolean;
  maxLength?: number;
  required?: boolean;
  showCounter?: boolean;
}

export const TextArea: FC<TextAreaProps> = ({
  name,
  value = '',
  onChange,
  onBlur,
  label,
  placeholder = '',
  disabled = false,
  supportMessage = '',
  InputProps,
  size = 'small',
  readOnly = false,
  maxLength,
  required = false,
  showCounter = true,
}) => {
  const isReadOnly = InputProps?.readOnly ?? readOnly;
  const mode = supportMessage ? 'error' : 'informative';

  return (
    <Grid
      item
      xs={12}
      sx={{ marginBottom: 2, width: '100%' }}
    >
      <ODSTextArea
        id={name}
        name={name}
        size={size}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        labelText={label}
        placeholder={placeholder}
        disabled={disabled}
        supportMessage={supportMessage}
        mode={mode}
        {...(InputProps && { InputProps })}
        readOnly={isReadOnly}
        maxLength={maxLength}
        required={required}
        showCounter={showCounter}
      />
    </Grid>
  );
};
